import { ReactNode } from 'react'

import { Text } from '@components/core/text'

export const Title = ({ children }: { children: ReactNode }) => (
  <Text variant='button' weight='semibold' className='text-primary-darker'>
    {children}
  </Text>
)
